import { useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/services/auth/auth-context";

export default function ClientCreationWarning() {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <svg
              className="h-8 w-8 text-yellow-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <title>Warning</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.314 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-gray-900">Staff/Admin Notice</h3>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-sm text-gray-700 mb-3">
            You currently have {isAdmin ? "admin" : "staff"} access but no client profile exists.
          </p>
          <p className="text-sm text-gray-700 mb-3">
            <strong>Do you want to create a client profile?</strong>
          </p>
          <p className="text-xs text-gray-500">
            This is intended for demonstration or instructional purposes only. Creating a client
            profile will allow you to experience the client dashboard interface.
          </p>
        </div>

        <div className="flex space-x-3">
          <Button
            onClick={() => navigate({ to: "/clientdashboard/onboard" })}
            className="flex-1 px-4 py-2F"
          >
            Create Client Profile
          </Button>
          <Button
            variant={"secondary"}
            onClick={() => navigate({ to: "/" })} // or wherever you want them to go back to
            className="flex-1"
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
